import { render, staticRenderFns } from "./MembershipGroupPrivilegeResvePopup.vue?vue&type=template&id=2772c312&"
import script from "./MembershipGroupPrivilegeResvePopup.vue?vue&type=script&lang=js&"
export * from "./MembershipGroupPrivilegeResvePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports